(function () {
  function uid() {
    return 'pv_' + Math.random().toString(36).slice(2) + '_' + Date.now().toString(36);
  }

  function getStorageKey(token) {
    return 'poster_preview_' + token;
  }

  function safeSetLocalStorage(key, val) {
    try {
      localStorage.setItem(key, val);
      return true;
    } catch (e) {
      return false;
    }
  }

  function findSectionIdFromRoot(root) {
    if (!root || !root.id) return null;
    var prefix = 'MainProduct-';
    if (root.id.indexOf(prefix) !== 0) return null;
    return root.id.slice(prefix.length);
  }

  function isTransparent(bg) {
    if (!bg) return true;
    return bg === 'transparent' || bg === 'rgba(0, 0, 0, 0)';
  }

  function waitForImages(node, timeoutMs) {
    timeoutMs = timeoutMs || 2500;
    if (!node) return Promise.resolve();

    var imgs = Array.prototype.slice.call(node.querySelectorAll('img'));
    if (!imgs.length) return Promise.resolve();

    return new Promise(function (resolve) {
      var done = false;

      var t = setTimeout(function () {
        if (done) return;
        done = true;
        resolve();
      }, timeoutMs);

      var pending = 0;

      function finishOne() {
        pending--;
        if (pending <= 0 && !done) {
          done = true;
          clearTimeout(t);
          resolve();
        }
      }

      imgs.forEach(function (img) {
        try { img.crossOrigin = 'anonymous'; } catch (e) {}
        if (img.complete && img.naturalWidth > 0) return;

        pending++;
        img.addEventListener('load', finishOne, { once: true });
        img.addEventListener('error', finishOne, { once: true });
      });

      if (pending === 0 && !done) {
        done = true;
        clearTimeout(t);
        resolve();
      }
    });
  }

  // Rasterize <img src="...svg"> -> PNG dataURL (SVG často selže v html2canvas)
  function rasterizeSvgImgs(node, timeoutMs) {
    timeoutMs = timeoutMs || 2000;
    if (!node) return Promise.resolve({ restore: function () {} });

    var imgs = Array.prototype.slice.call(node.querySelectorAll('img'));
    var svgImgs = imgs.filter(function (img) {
      var src = (img.getAttribute('src') || '').toLowerCase();
      return src.indexOf('.svg') !== -1;
    });

    if (!svgImgs.length) return Promise.resolve({ restore: function () {} });

    var originals = [];

    function toAbsUrl(url) {
      var abs = url || '';
      if (abs.indexOf('//') === 0) abs = window.location.protocol + abs;
      return abs;
    }

    function fetchText(url) {
      var abs = toAbsUrl(url);
      return fetch(abs, { mode: 'cors', credentials: 'same-origin' })
        .then(function (r) { return r.text(); });
    }

    function svgTextToPngDataUrl(svgText, w, h) {
      return new Promise(function (resolve) {
        try {
          var blob = new Blob([svgText], { type: 'image/svg+xml;charset=utf-8' });
          var blobUrl = URL.createObjectURL(blob);

          var img = new Image();
          img.crossOrigin = 'anonymous';

          var done = false;
          var t = setTimeout(function () {
            if (done) return;
            done = true;
            try { URL.revokeObjectURL(blobUrl); } catch (e) {}
            resolve(null);
          }, timeoutMs);

          img.onload = function () {
            if (done) return;
            done = true;
            clearTimeout(t);

            try {
              var cw = w || img.naturalWidth || 1200;
              var ch = h || img.naturalHeight || 1200;

              var c = document.createElement('canvas');
              c.width = cw;
              c.height = ch;

              var ctx = c.getContext('2d');
              ctx.imageSmoothingEnabled = true;
              ctx.imageSmoothingQuality = 'high';

              var iw = img.naturalWidth || cw;
              var ih = img.naturalHeight || ch;

              var r = Math.min(cw / iw, ch / ih);
              var dw = Math.round(iw * r);
              var dh = Math.round(ih * r);
              var dx = Math.round((cw - dw) / 2);
              var dy = Math.round((ch - dh) / 2);

              ctx.clearRect(0, 0, cw, ch);
              ctx.drawImage(img, dx, dy, dw, dh);

              var png = c.toDataURL('image/png');
              try { URL.revokeObjectURL(blobUrl); } catch (e) {}
              resolve(png);
            } catch (e) {
              try { URL.revokeObjectURL(blobUrl); } catch (e2) {}
              resolve(null);
            }
          };

          img.onerror = function () {
            if (done) return;
            done = true;
            clearTimeout(t);
            try { URL.revokeObjectURL(blobUrl); } catch (e) {}
            resolve(null);
          };

          img.src = blobUrl;
        } catch (e) {
          resolve(null);
        }
      });
    }

    return Promise.all(svgImgs.map(function (imgEl) {
      try {
        var src = imgEl.getAttribute('src') || '';
        originals.push({ el: imgEl, src: src });

        var rect = imgEl.getBoundingClientRect();
        var scale = 3;

        var w = Math.max(1, Math.round(rect.width * scale));
        var h = Math.max(1, Math.round(rect.height * scale));

        var maxSide = 2200;
        if (w > maxSide || h > maxSide) {
          var k = Math.min(maxSide / w, maxSide / h);
          w = Math.max(1, Math.round(w * k));
          h = Math.max(1, Math.round(h * k));
        }

        return fetchText(src)
          .then(function (svgText) { return svgTextToPngDataUrl(svgText, w, h); })
          .then(function (pngDataUrl) {
            if (pngDataUrl) imgEl.setAttribute('src', pngDataUrl);
          })
          .catch(function () {});
      } catch (e) {
        return Promise.resolve();
      }
    })).then(function () {
      return {
        restore: function () {
          for (var i = 0; i < originals.length; i++) {
            try { originals[i].el.setAttribute('src', originals[i].src); } catch (e) {}
          }
        }
      };
    });
  }

  function readHidden(sectionRoot, name) {
    var el = sectionRoot.querySelector('input[name="properties[' + name + ']"]');
    return el ? (el.value || '').trim() : '';
  }

  function parseStyleUserAndId(styleUri) {
    styleUri = (styleUri || '').trim();
    var m = styleUri.match(/^mapbox:\/\/styles\/([^\/]+)\/([^\/\?\#]+)$/i);
    if (!m) return null;
    return { user: m[1], id: m[2] };
  }

  function blobToDataUrl(blob) {
    return new Promise(function (resolve) {
      try {
        var r = new FileReader();
        r.onload = function () { resolve(r.result || null); };
        r.onerror = function () { resolve(null); };
        r.readAsDataURL(blob);
      } catch (e) {
        resolve(null);
      }
    });
  }

  function fetchStaticMapDataUrl(sectionRoot, w, h) {
    var lat = parseFloat(readHidden(sectionRoot, 'LATITUDE'));
    var lng = parseFloat(readHidden(sectionRoot, 'LONGITUDE'));
    var zoom = parseFloat(readHidden(sectionRoot, 'ZOOM'));
    if (!isFinite(lat) || !isFinite(lng)) return Promise.resolve(null);
    if (!isFinite(zoom)) zoom = 11;

    var styleUri = readHidden(sectionRoot, '_MAP_STYLE') || '';
    var parsed = parseStyleUserAndId(styleUri);
    if (!parsed) return Promise.resolve(null);

    var token = (window.mapboxgl && window.mapboxgl.accessToken) ? window.mapboxgl.accessToken : '';
    if (!token || token.length < 10) return Promise.resolve(null);

    // Static API limit (běžný endpoint): max 1280x1280
    var W = Math.max(64, Math.min(1280, Math.round(w)));
    var H = Math.max(64, Math.min(1280, Math.round(h)));

    var url =
      'https://api.mapbox.com/styles/v1/' +
      encodeURIComponent(parsed.user) + '/' +
      encodeURIComponent(parsed.id) +
      '/static/' +
      encodeURIComponent(lng.toFixed(6)) + ',' +
      encodeURIComponent(lat.toFixed(6)) + ',' +
      encodeURIComponent(zoom.toFixed(2)) + ',0,0/' +
      W + 'x' + H +
      '?access_token=' + encodeURIComponent(token) +
      '&logo=false&attribution=false';

    return fetch(url, { mode: 'cors', cache: 'no-store' })
      .then(function (r) { if (!r.ok) return null; return r.blob(); })
      .then(function (blob) { if (!blob) return null; return blobToDataUrl(blob); })
      .catch(function () { return null; });
  }

  // ✅ FIX: pro KULATÝ layout html2canvas neumí mask-image => dočasně uděláme kruh přes overflow+border-radius
  function applyKulatýCaptureFix(previewRoot, sectionId) {
  if (!previewRoot) return { restore: function() {} };
  if (!previewRoot.classList.contains('poster-preview--layout-kulaty')) return { restore: function() {} };

  var imageBg = previewRoot.querySelector('.poster-preview__image-bg');
  var stage = document.getElementById('MapStage-' + sectionId);
  if (!imageBg || !stage) return { restore: function() {} };

  var kulatyMask = imageBg.querySelector('.kulaty-mask');
  var prevMaskDisplay = kulatyMask ? kulatyMask.style.display : null;

  // uložíme původní umístění stage v DOM
  var originalParent = stage.parentNode;
  var originalNext = stage.nextSibling;

// zmenšení + vycentrování kruhu
var CIRCLE_SIZE = 83; // % šířky
var CIRCLE_TOP  = 13; // %

var clip = document.createElement('div');
clip.className = 'pv-kulaty-clip';
clip.style.position = 'absolute';
clip.style.left = ((100 - CIRCLE_SIZE) / 2) + '%';
clip.style.top = CIRCLE_TOP + '%';

// ✅ klíč: čtverec podle šířky (ne podle výšky kontejneru)
clip.style.width = CIRCLE_SIZE + '%';
clip.style.aspectRatio = '1 / 1';  // 👈 udělá z toho čtverec
clip.style.height = 'auto';        // 👈 nepoužívej % výšku

clip.style.transform = 'none';
clip.style.borderRadius = '50%';
clip.style.overflow = 'hidden';
clip.style.pointerEvents = 'none';
clip.style.zIndex = '4';
clip.style.backgroundColor = 'transparent';



  // schovej mask (html2canvas ji neumí a často “přemaluje” mapu pryč)
  if (kulatyMask) kulatyMask.style.display = 'none';

  // ✅ KLÍČ: přesuneme stage do clipu (zachová inset a celé chování)
  clip.appendChild(stage);
  imageBg.appendChild(clip);

  // volitelně: kdyby ti do capture lezl label, necháme ho jak máš v layoutu (nic neměníme)

  return {
    restore: function() {
      try {
        // vrátit stage zpět na původní místo
        if (originalParent) {
          if (originalNext) originalParent.insertBefore(stage, originalNext);
          else originalParent.appendChild(stage);
        }
      } catch (e) {}

      try { if (clip && clip.parentNode) clip.parentNode.removeChild(clip); } catch (e) {}
      try { if (kulatyMask) kulatyMask.style.display = prevMaskDisplay || ''; } catch (e) {}
    }
  };
}


  // ✅ FIX 2.0: NEšahat na transformovaný #MapboxMap, ale dát static mapu jako background na #MapStage
  function injectStaticMapIntoStage(sectionRoot, sectionId) {
    var stage = document.getElementById('MapStage-' + sectionId);
    var mapWrap = document.getElementById('MapboxMap-' + sectionId);
    if (!stage || !mapWrap) return Promise.resolve({ restore: function () {} });

    var stageRect = stage.getBoundingClientRect();

    // vyšší kvalita (2x), ale hlídáme max 1280
    var w = Math.max(240, Math.round(stageRect.width * 2));
    var h = Math.max(240, Math.round(stageRect.height * 2));

    var prevStageBg = stage.style.backgroundImage;
    var prevStageSize = stage.style.backgroundSize;
    var prevStagePos = stage.style.backgroundPosition;
    var prevStageRepeat = stage.style.backgroundRepeat;

    var prevMapVis = mapWrap.style.visibility;
    var prevMapOpacity = mapWrap.style.opacity;

    // schovej mapbox controls (ať nelezou do capture)
    var ctrl = mapWrap.querySelector('.mapboxgl-control-container');
    var prevCtrlDisplay = ctrl ? ctrl.style.display : null;

    return fetchStaticMapDataUrl(sectionRoot, w, h).then(function (dataUrl) {
      if (!dataUrl) return { restore: function () {} };

      // pozadí na stage
      stage.style.backgroundImage = 'url("' + dataUrl + '")';
      stage.style.backgroundSize = 'cover';
      stage.style.backgroundPosition = 'center center';
      stage.style.backgroundRepeat = 'no-repeat';

      // schovej živý WebGL, ale nech DOM (layout) beze změny
      mapWrap.style.visibility = 'hidden';
      mapWrap.style.opacity = '0';
      if (ctrl) ctrl.style.display = 'none';

      return {
        restore: function () {
          try {
            stage.style.backgroundImage = prevStageBg || '';
            stage.style.backgroundSize = prevStageSize || '';
            stage.style.backgroundPosition = prevStagePos || '';
            stage.style.backgroundRepeat = prevStageRepeat || '';

            mapWrap.style.visibility = prevMapVis || '';
            mapWrap.style.opacity = prevMapOpacity || '';

            if (ctrl) ctrl.style.display = prevCtrlDisplay || '';
          } catch (e) {}
        }
      };
    });
  }

  function capturePreview(sectionRoot, sectionId) {
    if (!sectionRoot || !sectionId) return;

    var tokenInput = sectionRoot.querySelector('#PreviewToken-' + sectionId);
    if (!tokenInput) return;

    var token = tokenInput.value || uid();
    tokenInput.value = token;

    var previewRoot =
      sectionRoot.querySelector('.poster-preview[data-poster-section="' + sectionId + '"]') ||
      sectionRoot.querySelector('.poster-preview');
    if (!previewRoot) return;

    var innerNode = previewRoot.querySelector('.poster-preview__inner') || previewRoot;
    if (!innerNode || !window.html2canvas) return;

    var imageBg = previewRoot.querySelector('.poster-preview__image-bg');
    var shouldInvertLetter = previewRoot.classList.contains('poster-preview--invert-svg');

    var prevInlineBg = innerNode.style.backgroundColor;
    var computedBg = window.getComputedStyle(innerNode).backgroundColor;
    var forcedBg = false;
    if (isTransparent(computedBg)) {
      innerNode.style.backgroundColor = '#ffffff';
      forcedBg = true;
    }

    // ✅ vyměníme mapu za static background na stage (bez transform bugů)
    injectStaticMapIntoStage(sectionRoot, sectionId).then(function (mapSwap) {
      // ✅ a pokud je KULATÝ layout: schovej mask a nahraď ji kruhovým clipem (html2canvas-safe)
      var kulatyFix = applyKulatýCaptureFix(previewRoot, sectionId);

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          waitForImages(innerNode, 2500).then(function () {
            rasterizeSvgImgs(innerNode, 2500).then(function (svgR) {
              var isCernyRamecek = previewRoot.classList.contains('poster-preview--layout-cerny-ramecek');

              html2canvas(innerNode, {
                backgroundColor: isCernyRamecek ? '#000000' : '#ffffff',
                scale: 1.5,
                useCORS: true,
                allowTaint: true,
                cacheBust: true,
                imageTimeout: 15000
              })
                .then(function (canvas) {
                  try { if (svgR && svgR.restore) svgR.restore(); } catch (e) {}
                  try { if (kulatyFix && kulatyFix.restore) kulatyFix.restore(); } catch (e) {}
                  try { if (mapSwap && mapSwap.restore) mapSwap.restore(); } catch (e) {}
                  if (forcedBg) innerNode.style.backgroundColor = prevInlineBg || '';

                  var targetW = 420;
                  var outCanvas = canvas;

                  if (canvas.width > targetW) {
                    var ratio = targetW / canvas.width;
                    var outW = Math.round(canvas.width * ratio);
                    var outH = Math.round(canvas.height * ratio);

                    outCanvas = document.createElement('canvas');
                    outCanvas.width = outW;
                    outCanvas.height = outH;

                    var octx = outCanvas.getContext('2d');
                    octx.imageSmoothingEnabled = true;
                    octx.imageSmoothingQuality = 'high';
                    octx.drawImage(canvas, 0, 0, outW, outH);
                  }

                  if (shouldInvertLetter && imageBg) {
                    try {
                      var innerRect = innerNode.getBoundingClientRect();
                      var bgRect = imageBg.getBoundingClientRect();

                      var scaleX2 = outCanvas.width / innerRect.width;
                      var scaleY2 = outCanvas.height / innerRect.height;

                      var rx = Math.max(0, Math.round((bgRect.left - innerRect.left) * scaleX2));
                      var ry = Math.max(0, Math.round((bgRect.top - innerRect.top) * scaleY2));
                      var rw = Math.min(outCanvas.width - rx, Math.round(bgRect.width * scaleX2));
                      var rh = Math.min(outCanvas.height - ry, Math.round(bgRect.height * scaleY2));

                      var ctx = outCanvas.getContext('2d');
                      var imgData = ctx.getImageData(rx, ry, rw, rh);
                      var d = imgData.data;

                      var maxDark = 70;
                      var minAlpha = 10;

                      for (var i = 0; i < d.length; i += 4) {
                        var rr = d[i], gg = d[i + 1], bb = d[i + 2], aa = d[i + 3];
                        if (aa > minAlpha && rr < maxDark && gg < maxDark && bb < maxDark) {
                          d[i] = 255; d[i + 1] = 255; d[i + 2] = 255;
                        }
                      }

                      ctx.putImageData(imgData, rx, ry);
                    } catch (e) {}
                  }

                  var dataUrl = outCanvas.toDataURL('image/jpeg', 0.72);

                  var ok = safeSetLocalStorage(getStorageKey(token), dataUrl);
                  if (ok) {
                    window.dispatchEvent(new CustomEvent('posterPreview:stored', { detail: { token: token } }));
                  }
                })
                .catch(function () {
                  try { if (svgR && svgR.restore) svgR.restore(); } catch (e) {}
                  try { if (kulatyFix && kulatyFix.restore) kulatyFix.restore(); } catch (e) {}
                  try { if (mapSwap && mapSwap.restore) mapSwap.restore(); } catch (e) {}
                  if (forcedBg) innerNode.style.backgroundColor = prevInlineBg || '';
                });
            });
          });
        });
      });
    });
  }

  function bindToSection(sectionRoot) {
    var sectionId = findSectionIdFromRoot(sectionRoot);
    if (!sectionId) return;

    var tokenInput = sectionRoot.querySelector('#PreviewToken-' + sectionId);
    if (tokenInput && !tokenInput.value) tokenInput.value = uid();

    if (sectionRoot.dataset.posterPreviewBound === '1') return;
    sectionRoot.dataset.posterPreviewBound = '1';

    sectionRoot.addEventListener('click', function (e) {
      var btn = e.target.closest('button[type="submit"], input[type="submit"]');
      if (!btn) return;
      if (!sectionRoot.contains(btn)) return;
      if (tokenInput) tokenInput.value = uid();
    }, true);
  }

  function init() {
    var roots = document.querySelectorAll('[id^="MainProduct-"]');
    if (!roots || !roots.length) return;
    for (var i = 0; i < roots.length; i++) bindToSection(roots[i]);
  }

  function patchFetchForCartAdd() {
    if (window.__posterPreviewFetchPatched) return;
    window.__posterPreviewFetchPatched = true;

    var originalFetch = window.fetch;
    if (!originalFetch) return;

    window.fetch = function () {
      var args = arguments;
      var url = args && args[0] ? args[0] : '';
      var urlStr = '';

      try {
        urlStr = (typeof url === 'string') ? url : (url && url.url ? url.url : '');
      } catch (e) {
        urlStr = '';
      }

      var isAdd =
        typeof urlStr === 'string' &&
        (urlStr.indexOf('/cart/add') !== -1 || urlStr.indexOf('/cart/add.js') !== -1);

      return originalFetch.apply(this, args).then(function (res) {
        if (isAdd && res && res.ok) {
          try {
            var activeSection = null;

            var activeEl = document.activeElement;
            if (activeEl) {
              var sec = activeEl.closest && activeEl.closest('section[id^="MainProduct-"]');
              if (sec) activeSection = sec;
            }

            if (!activeSection) {
              var all = document.querySelectorAll('section[id^="MainProduct-"]');
              for (var i = 0; i < all.length; i++) {
                var s = all[i];
                if (s.offsetParent !== null) { activeSection = s; break; }
              }
            }

            if (activeSection) {
              var sectionId = findSectionIdFromRoot(activeSection);
              if (sectionId) capturePreview(activeSection, sectionId);
            }
          } catch (e) {}
        }

        return res;
      });
    };
  }

  document.addEventListener('DOMContentLoaded', function () {
    init();
    patchFetchForCartAdd();
  });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
})();
